/**
 * iurop-cart-drawer.js — Sidecart dinámico (Atisse, NOTAS §3.4)
 *
 * - Mutaciones de carrito DENTRO del drawer (cantidad +/- y eliminar) vía
 *   /cart/change.js con Section Rendering → re-pinta el drawer en 1 ida.
 * - Adiciones EXTERNAS (PDP, cards, upsells) van por el quick-add global de
 *   header.js, que tras añadir dispara `cart:updated` → aquí refrescamos el
 *   drawer (Section Rendering por GET) y lo ABRIMOS.
 * - Temporizador de reserva: arranca al tener ítems, persiste en localStorage,
 *   se reinicia si vacías el carrito y lo empiezas de nuevo, y cambia el copy
 *   al llegar a 0. Minutos y textos son editables (settings → Liquid).
 * - Modal Klarna (mismo contenido que la PDP), scoped al drawer.
 *
 * El abrir/cerrar base lo gestiona global.js por atributos:
 *   [data-open] en [data-cart-drawer] + [data-drawer-open] en <html>.
 */
(function () {
  'use strict';

  var RESERVE_KEY = 'iurop:cart-reserve-start';
  var reserveTimer = null;
  var busy = false;

  function drawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  // --- Rodar un número (odómetro) hacia un nuevo valor ---------------------
  function rollTo(el, toText) {
    toText = String(toText);
    var from = el.getAttribute('data-roll-text');
    if (from == null) from = (el.textContent || '').trim();
    el.setAttribute('data-roll-text', toText);
    if (window.IuropRoll && from !== toText) {
      window.IuropRoll.animate(el, from, toText);
    } else {
      el.textContent = toText;
    }
  }

  // --- Contadores del HEADER (fuera del drawer; el del drawer lo hace swap) --
  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (el.closest('[data-cart-drawer]')) return;
      el.classList.toggle('is-hidden', n === 0);
      rollTo(el, n);
    });
  }

  // --- Abrir / cerrar (mismo contrato que global.js) -----------------------
  function openDrawer() {
    var el = drawer();
    if (!el) return;
    el.setAttribute('data-open', 'true');
    document.documentElement.setAttribute('data-drawer-open', 'true');
  }
  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-drawer-open');
  }

  // --- Temporizador de reserva ---------------------------------------------
  function fmt(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initReserve() {
    if (reserveTimer) {
      window.clearInterval(reserveTimer);
      reserveTimer = null;
    }
    var el = drawer();
    var bar = el && el.querySelector('[data-cart-reserve]');

    // Sin barra = carrito vacío → limpia el inicio para que reinicie al volver.
    if (!bar) {
      try { window.localStorage.removeItem(RESERVE_KEY); } catch (e) {}
      return;
    }

    var minutes = parseFloat(bar.getAttribute('data-minutes')) || 10;
    var durationMs = minutes * 60 * 1000;
    var countEl = bar.querySelector('[data-reserve-count]');
    var activeEl = bar.querySelector('[data-reserve-active]');
    var expiredEl = bar.querySelector('[data-reserve-expired]');

    var start;
    try {
      start = parseInt(window.localStorage.getItem(RESERVE_KEY), 10);
    } catch (e) {
      start = NaN;
    }
    if (!start || isNaN(start)) {
      start = Date.now();
      try { window.localStorage.setItem(RESERVE_KEY, String(start)); } catch (e) {}
    }

    var tick = function () {
      var remaining = durationMs - (Date.now() - start);
      if (remaining <= 0) {
        if (activeEl) activeEl.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (reserveTimer) {
          window.clearInterval(reserveTimer);
          reserveTimer = null;
        }
        return;
      }
      if (activeEl) activeEl.hidden = false;
      if (expiredEl) expiredEl.hidden = true;
      if (countEl) countEl.textContent = fmt(remaining);
    };

    tick();
    reserveTimer = window.setInterval(tick, 1000);
  }

  // --- Swap del contenido del drawer (Section Rendering) -------------------
  function swapFromHTML(html) {
    var live = drawer();
    if (!live) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-cart-drawer]');
    if (!next) return;

    // Conserva la posición de scroll del cuerpo (único scroller) entre re-pintados.
    var oldBody = live.querySelector('.cart-drawer__body');
    var scrollTop = oldBody ? oldBody.scrollTop : 0;

    // Captura los valores VIEJOS de los números antes de re-pintar (para rodar).
    var ROLL = ['[data-cart-count]', '[data-cart-total]', '[data-cart-installment]', '[data-cart-remaining]'];
    var oldRoll = {};
    ROLL.forEach(function (sel) {
      var e = live.querySelector(sel);
      oldRoll[sel] = e ? (e.getAttribute('data-roll-text') || (e.textContent || '').trim()) : null;
    });

    live.innerHTML = next.innerHTML;

    var newBody = live.querySelector('.cart-drawer__body');
    if (newBody) newBody.scrollTop = scrollTop;

    // iOS: el estado vacío se inyecta por innerHTML y a veces no recalcula
    // alturas hasta un reflow (la rejilla de colecciones colapsaba y los
    // upsells se solapaban). Forzamos un reflow síncrono de ese bloque.
    var emptyEl = live.querySelector('.apodemia-cart-drawer__empty');
    if (emptyEl) { void emptyEl.offsetHeight; }

    // Rueda los números del drawer desde su valor viejo al nuevo (odómetro).
    ROLL.forEach(function (sel) {
      var e = live.querySelector(sel);
      if (!e) return;
      var target = e.getAttribute('data-roll-text') || (e.textContent || '').trim();
      if (oldRoll[sel] != null && window.IuropRoll && target !== oldRoll[sel]) {
        window.IuropRoll.animate(e, oldRoll[sel], target);
      }
    });

    // Contador del header (fuera del drawer) → sincroniza + rueda.
    var dc = live.querySelector('[data-cart-count]');
    var newCount = dc ? parseInt(dc.getAttribute('data-roll-text') || dc.textContent, 10) || 0 : 0;
    updateCounts(newCount);

    initReserve();
    reapplyLooks();
    document.dispatchEvent(new CustomEvent('cart:rendered'));
  }

  // --- Grupos de look (item compacto con desplegable) -----------------------
  // El estado abierto sobrevive a los re-renders del Section Rendering API.
  var openLooks = {};

  function setLookOpen(group, open) {
    var head = group.querySelector('[data-look-toggle]');
    var lines = group.querySelector('[data-look-lines]');
    if (!head || !lines) return;
    lines.hidden = !open;
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    group.classList.toggle('is-open', open);
  }

  function reapplyLooks() {
    document.querySelectorAll('[data-look-group]').forEach(function (g) {
      var key = g.getAttribute('data-look-key');
      if (key && openLooks[key]) setLookOpen(g, true);
    });
  }

  // Refresco por GET (para adiciones externas que no devuelven secciones).
  function refresh() {
    var url = window.location.pathname + '?section_id=iurop-cart-drawer';
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return;
        swapFromHTML(html); // ya sincroniza y rueda los contadores
      })
      .catch(function () {});
  }

  // --- Cambiar cantidad / eliminar línea (change.js + secciones) -----------
  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('data-busy', 'true');

    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && cart.sections && cart.sections['iurop-cart-drawer']) {
          swapFromHTML(cart.sections['iurop-cart-drawer']); // sincroniza contadores
        } else {
          return refresh();
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var d = drawer();
        if (d) d.removeAttribute('data-busy');
      });
  }

  // Actualiza varias líneas a la vez (p. ej. quitar joya + su grabado juntos).
  function updateLines(updates) {
    if (busy) return;
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('data-busy', 'true');
    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    fetch(updateUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && cart.sections && cart.sections['iurop-cart-drawer']) {
          swapFromHTML(cart.sections['iurop-cart-drawer']);
        } else {
          return refresh();
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var d = drawer();
        if (d) d.removeAttribute('data-busy');
      });
  }

  // --- Añadir upsell ("Combínalo con") dentro del drawer -------------------
  function addLine(variantId) {
    if (busy) return;
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('data-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections['iurop-cart-drawer']) {
          swapFromHTML(data.sections['iurop-cart-drawer']);
        } else {
          return refresh();
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var d = drawer();
        if (d) d.removeAttribute('data-busy');
      });
  }

  // --- Modal Klarna --------------------------------------------------------
  function klarnaModal() {
    var el = drawer();
    return el && el.querySelector('[data-cart-klarna]');
  }
  function openKlarna() {
    var m = klarnaModal();
    if (m) m.hidden = false;
  }
  function closeKlarna() {
    var m = klarnaModal();
    if (m) m.hidden = true;
  }

  // --- Delegación de eventos ----------------------------------------------
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    if (up) {
      e.preventDefault();
      var q = (parseInt(up.getAttribute('data-qty'), 10) || 0) + 1;
      changeLine(up.getAttribute('data-key'), q);
      return;
    }

    var down = e.target.closest('[data-qty-down]');
    if (down) {
      e.preventDefault();
      var cur = parseInt(down.getAttribute('data-qty'), 10) || 0;
      changeLine(down.getAttribute('data-key'), Math.max(0, cur - 1));
      return;
    }

    var lt = e.target.closest('[data-look-toggle]');
    if (lt) {
      e.preventDefault();
      var group = lt.closest('[data-look-group]');
      if (group) {
        var key = group.getAttribute('data-look-key') || '';
        var open = !group.classList.contains('is-open');
        openLooks[key] = open;
        setLookOpen(group, open);
      }
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      var rKey = remove.getAttribute('data-key');
      var rLine = remove.closest('[data-cart-line]');
      var engId = rLine && rLine.getAttribute('data-engrave-id');
      if (engId) {
        // Al quitar la joya grabada, se quita también su línea de servicio (+precio).
        var upd = {};
        upd[rKey] = 0;
        document.querySelectorAll('[data-cart-line][data-engrave-id="' + engId + '"]').forEach(function (l) {
          var k = l.getAttribute('data-line-key');
          if (k) upd[k] = 0;
        });
        updateLines(upd);
        return;
      }
      changeLine(rKey, 0);
      return;
    }

    var add = e.target.closest('[data-cart-add]');
    if (add) {
      e.preventDefault();
      addLine(parseInt(add.getAttribute('data-cart-add'), 10));
      return;
    }

    if (e.target.closest('[data-cart-klarna-open]')) {
      e.preventDefault();
      openKlarna();
      return;
    }
    if (e.target.closest('[data-cart-klarna-close]')) {
      e.preventDefault();
      closeKlarna();
      return;
    }
  });

  // Esc: cierra primero el modal Klarna (captura → corta el cierre del drawer
  // que hace global.js en fase de burbuja).
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var m = klarnaModal();
      if (m && !m.hidden) {
        closeKlarna();
        e.stopPropagation();
      }
    },
    true
  );

  // Adición externa → refresca el contenido. Por defecto abre el drawer; con
  // detail.noOpen (p. ej. el modal quick-view / hero) solo refresca en silencio
  // para no tapar el modal con el sidecart.
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.noOpen) {
      refresh();
    } else {
      refresh().then(openDrawer);
    }
  });

  // --- Swipe para cerrar (móvil / iOS) -------------------------------------
  // El panel entra por la derecha → arrastrar a la derecha lo descarta. Solo se
  // activa si el gesto es claramente horizontal (no al hacer scroll vertical).
  var swStartX = null, swStartY = null, swPanel = null, swActive = false;

  document.addEventListener('touchstart', function (e) {
    var p = e.target.closest('[data-cart-panel]');
    if (!p) return;
    swStartX = e.touches[0].clientX;
    swStartY = e.touches[0].clientY;
    swPanel = p;
    swActive = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (swStartX === null || !swPanel) return;
    var dx = e.touches[0].clientX - swStartX;
    var dy = e.touches[0].clientY - swStartY;
    if (!swActive) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      // Bloquea el gesto como swipe solo si domina el eje X hacia la derecha.
      swActive = dx > 0 && Math.abs(dx) > Math.abs(dy);
      if (!swActive) { swStartX = null; swPanel = null; return; }
    }
    if (dx > 0) {
      swPanel.style.transition = 'none';
      swPanel.style.transform = 'translateX(' + dx + 'px)';
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (swStartX === null || !swPanel) return;
    var dx = e.changedTouches[0].clientX - swStartX;
    var panel = swPanel;
    panel.style.transition = '';
    panel.style.transform = '';
    if (swActive && dx > panel.offsetWidth * 0.33) {
      closeDrawer();
    }
    swStartX = null; swStartY = null; swPanel = null; swActive = false;
  }, { passive: true });

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReserve);
  } else {
    initReserve();
  }
})();
